<template>
    <app-overlay-loader v-if="mainPreloader" />
    <div v-else class="content-wrapper reports">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :directory="$t('reports')" :icon="'bar-chart'" :page-title="pageTitle" />
            </div>
        </div>
        <div class="row d-flex align-items-start justify-content-start filters-wrapper">
            <div class="col-sm-6 col-md-3 col-lg-2 col-12 pr-0 mb-4">
                <app-input v-model="year" class="filter-input" :list="yearList" list-value-field="name" type="select"
                    @input="getCountValueFilterValues" />
            </div>
            <div class="col-sm-6 col-12 pl-0 mb-4">
                <app-filter :filters="filters" class="ml-4" @get-values="monthValue" />
            </div>

        </div>
        <div class="row">
            <div class="col-12 mb-primary">
                <app-overlay-loader v-if="tabLoader" />
                <app-tab-report-cost v-else :tabs="tabs" :tabdate="tabdate" />


                <!--<div class="card card-with-shadow border-0 h-100">
                    <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                        <div class="d-flex justify-content-end align-items-center">
                            {{ reportData }}
                        </div>
                    </div>
                </div>-->
            </div>
        </div>
    </div>
</template>
<script>
import { FormMixin } from "@core/mixins/form/FormMixin";
import { numberFormatter, numberWithCurrencySymbol, urlGenerator } from "@app/Helpers/helpers";
import { collect } from "@app/Helpers/Collection";
export default {
    name: "Reports",
    mixins: [FormMixin],
    data() {
        return {
            numberWithCurrencySymbol,
            numberFormatter,
            urlGenerator,
            mainPreloader: false,
            tabLoader: false,
            preLoader: false,
            pageTitle: this.$t('Reports_cost'),
            month: '',
            reportData: [],
            year: new Date().getFullYear(),
            yearList: [
                { id: 2021, name: 2021 },
                { id: 2022, name: 2022 },
                { id: 2023, name: 2023 },
                { id: 2024, name: 2024 },
                { id: 2025, name: 2025 },
                { id: 2026, name: 2026 },
            ],
            filters: [
                {
                    title: this.$t("reports_all_month"),
                    type: "checkbox",
                    key: "month",
                    listValueField: "name",
                    option: [
                        { id: 1, name: this.$t("reports_jan") },
                        { id: 2, name: this.$t("reports_feb") },
                        { id: 3, name: this.$t("reports_mar") },
                        { id: 4, name: this.$t("reports_apr") },
                        { id: 5, name: this.$t("reports_may") },
                        { id: 6, name: this.$t("reports_jun") },
                        { id: 7, name: this.$t("reports_jul") },
                        { id: 8, name: this.$t("reports_aug") },
                        { id: 9, name: this.$t("reports_sep") },
                        { id: 10, name: this.$t("reports_oct") },
                        { id: 11, name: this.$t("reports_nov") },
                        { id: 12, name: this.$t("reports_dec") },
                    ],
                },
            ],
            tabs: [
                {
                    "title": "tab_plus",
                    "name": "tab_report_cost_one",
                    "props": {
                        "type": "plus",
                        "labels": []
                    }
                },
                {
                    "title": "tab_minus",
                    "name": "tab_report_cost_two",
                    "props": {
                        "type": "minus",
                        "labels": []
                    }
                },
                {
                    "title": "tab_res",
                    "name": "tab_report_cost_tree",
                    "props": {
                        "type": "res",
                        "labels": []
                    }
                },
            ],
            tabdate: {
                "year": new Date().getFullYear(),
                "month": ''
            },

        };
    },
    mounted() {


    },
    created() {

    },
    methods: {
        getReport() {
            let year = 'year=' + this.year;
            let month = 'month=' + this.month;
            //this.preLoader = true;
            this.axiosGet('/crm/reportallcost?' + year + '&' + month)
                .then((res) => {
                    this.reportData = res.data;
                })
                .finally(() => {
                    this.preLoader = false;
                });
        },
        monthValue(value) {
            this.tabLoader = true;
            console.log(value);
            this.tabdate.month = value.month;
            setTimeout(() => {
                this.tabLoader = false;
            }, 200);
        },
        getCountValueFilterValues() {
            this.tabLoader = true;
            this.tabdate.year = this.year;
            setTimeout(() => {
                this.tabLoader = false;
            }, 200);
        }

    },
};
</script>
<style scoped>
.filter-item {
    min-width: 100px;
}
</style>
